var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"9.5","cy":"9.5","r":"8.5","stroke":"#ED1C24","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }